import { useContext } from 'react';
import { OrgContext } from '../../contexts/org';
export const useOrgContext = () => {
    const { org } = useContext(OrgContext);
    if (!org) {
        throw new Error('useOrgContext should be used within OrgContext');
    }
    return org;
};
